import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-title-row',
  templateUrl: './title-row.component.html',
  styleUrls: ['./title-row.component.scss']
})
export class TitleRowComponent implements OnChanges {
  @Input() options: any;
  slickOptions: any = {
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.1,
          initialSlide: 1
        }
      }
    ]
  };
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && this.options.unslickDesk) {
      this.slickOptions.responsive = [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.1,
            initialSlide: 1
          }
        }
      ]
    }
  }

}
